module.exports = __webpack_public_path__ + "static/media/Beer.a91eb51f.svg";